import { createSelector } from 'reselect';
import { flow, get, isEmpty, lte, keys, map, pickBy } from 'lodash/fp';

import selectionsBySideSelector from './selectionsBySideSelector';

export function getMaxedSides(selectionsBySide, teams, playersPerSideCap) {
  const pickMaxedIds = flow(
    pickBy(lte(playersPerSideCap)),
    keys
  );
  return isEmpty(teams) ? [] : map(x => teams[x].teamAbbr, pickMaxedIds(selectionsBySide));
}

const maxedSidesSelector = createSelector(
  selectionsBySideSelector,
  get('challenge.teams'),
  get('challenge.playersPerSideCap'),
  getMaxedSides
);

export default maxedSidesSelector;
